
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService } from '../../backend.service';
import { Document, KycPageResponse, PatchKycFlowUI } from './contracts/document';
import { ProofOfId, ProofOfAddress } from './enums/enum';
import { ApplicationService } from '../../application/application.service';
import { TokenService } from '../../token/token.service';
import { PoaAddress } from '../personal-details/contracts/personal-details';
import * as downloadFile from 'downloadjs';
import { environment } from '../../../environments/environment';


@Injectable()
export class DocumentsService {

  private documentUrl = '/documents/api/v1/customers/{customerId}/document';
  private documentContentUrl = '/documents/api/v1/document/{documentId}/Client';
  private savePoaAddressUrl = '/PersonalDetails/Customers/Address/Document';
  private checkIfAddressRequiredUrl = 'https://{environment}lender.zestmoney.in/dashboard/api/v1/merchant/{merchantId}/customer/{customerId}/isDocumentAddressRquired';
  private checkIfPhotoRequiredUrl = 'https://{environment}lender.zestmoney.in/dashboard/api/v1/merchant/{merchantId}/isphotorequired';
  private checkForNewKycPageUrl = '/kyc/api/v1/merchants/{merchantId}';
  private latestKYCDocWithThumbUrl = '/documents/api/v2/customers/{customerId}/document?label=Aadhaar&label=Passport&label=VoterId&label=DrivingLicense&withCompressedImage=false&withImageThumbnail=true&withContent=false&latestWithRelatedDocuments=true';
  private latestKYCPhotoWithThumbUrl = '/documents/api/v2/customers/{customerId}/document?label=Photo&withCompressedImage=false&withImageThumbnail=true&withContent=false&latest=true';
  private digiodocumentUrl = '/digio-nach/api/v1/customer/{customerId}/signedNach?applicationId={applicationId}';
  private patchKycUrl = '/kyc/compliance/api/v1/customers/{customerId}';
  private additionalDocDigioDocumentUrl = '/digio-nach/api/v1/customer/{customerId}/signedNach/additional-doc?applicationId={applicationId}';
  private documentUrlV2 = '/documents/api/v2/customers/{customerId}/document';

  private doorstepFeatureSwitch = '/switch/doorstep_switch.json';

  constructor(private backendService: BackendService, private applicationService: ApplicationService, private tokenService: TokenService) { }

  saveDocument(documentCategory: string, documentLabel: string, name: string, ext: string, content: string, isAdditionalDocument: boolean, isClicked?: boolean, documentRelationId?: string, documentPage?: string, channel?: string): Observable<any> {
    const applicationId = this.applicationService.getApplicationId() ? this.applicationService.getApplicationId() : null;
    if (documentLabel === ProofOfId.FrontOfAadhaar.toString() || documentLabel === ProofOfAddress.BackOfAadhaar.toString()) {
      documentLabel = 'Aadhaar';
    }
    const documentData = {
      documentCategory: documentCategory,
      documentLabel: documentLabel,
      fileName: name,
      fileExtension: ext,
      documentContent: content,
      isAdditionalDocument: isAdditionalDocument,
      merchantIdSource: this.applicationService.getMerchantId(),
      applicationContext: applicationId,
      isClicked: isClicked,
      documentRelationId: documentRelationId,
      documentPage: documentPage,
      channel: channel
    };
    return this.backendService.setData(this.documentUrl, documentData);
  }
  saveDocumentV2(documentCategory: string, documentLabel: string, name: string, ext: string, content: string, isAdditionalDocument: boolean, isClicked?: boolean, documentRelationId?: string, documentPage?: string, channel?: string): Observable<any> {
    const applicationId = this.applicationService.getApplicationId() ? this.applicationService.getApplicationId() : null;
    if (documentLabel === ProofOfId.FrontOfAadhaar.toString() || documentLabel === ProofOfAddress.BackOfAadhaar.toString()) {
      documentLabel = 'Aadhaar';
    }
    const documentData = {
      documentCategory: documentCategory,
      documentLabel: documentLabel,
      fileName: name,
      fileExtension: ext,
      documentContent: content,
      isAdditionalDocument: isAdditionalDocument,
      merchantIdSource: this.applicationService.getMerchantId(),
      applicationContext: applicationId,
      isClicked: isClicked,
      documentRelationId: documentRelationId,
      documentPage: documentPage,
      channel: channel
    };
    return this.backendService.setData(this.documentUrlV2, documentData);
  }
  saveDigioDocument(fileName: string, fileExtension: string, filecontent: string, additionalDocument: boolean, channel: string): Observable<any> {
    const digioDocumentData = {
      fileName: fileName,
      fileExtension: fileExtension,
      documentContent: filecontent,
      additionalDocument: additionalDocument,
      channel: channel
    };
    const applicationId = this.applicationService.getApplicationId();
    return this.backendService.setData(this.digiodocumentUrl.replace('{applicationId}', applicationId ? applicationId : ''), digioDocumentData, 'text');
  }
  saveDigioDocumentInAdditionalDoc(fileName: string, fileExtension: string, filecontent: string, additionalDocument: boolean, channel: string): Observable<any> {
    const digioDocumentDataInAdditionalDoc = {
      fileName: fileName,
      fileExtension: fileExtension,
      documentContent: filecontent,
      additionalDocument: additionalDocument,
      channel: channel
    };
    const applicationId = this.applicationService.getApplicationId();
    return this.backendService.setData(this.additionalDocDigioDocumentUrl.replace('{applicationId}', applicationId ? applicationId : ''), digioDocumentDataInAdditionalDoc);
  }
  getDocuments(): Observable<Document[]> {
    return this.backendService.getData(this.documentUrl);
  }
  getKYCDocuments(): Observable<Document[]> {
    return this.backendService.getData(this.latestKYCDocWithThumbUrl);
  }
  getKYCPhoto(): Observable<Document[]> {
    return this.backendService.getData(this.latestKYCPhotoWithThumbUrl);
  }
  base64StringToArrayBuffer(fileContent, fileType) {
    const binary_string = window.atob(fileContent);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return new Blob([bytes.buffer], { type: fileType === 'pdf' ? 'application/pdf;base64' : 'image/jpeg' });
  }
  downloadFileFromBase64String(filename: string, mimeType: string, base64String: string) {
    const blob = this.base64StringtoBlob(base64String, mimeType, 512);
    // const file = new File([blob], filename);
    downloadFile(blob, filename, mimeType);
  }
  downloadPdf(url: string, filename: string, mimeType: string) {
    const x = new XMLHttpRequest();
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = function(e) {downloadFile(x.response, filename, mimeType ); };
      x.send();
  }
  base64StringtoBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  checkIfPhotoRequired(merchantId: string): Observable<string> {
    let url = this.checkIfPhotoRequiredUrl;
    if (!environment.production) {
      url = url.replace('{environment}', 'staging-');
    } else {
      url = url.replace('{environment}', '');
    }
    return this.backendService.getData(url.replace('{merchantId}', merchantId), null, false, true, false, true);
  }
  fetchCompleteDocument(documentId): Observable<Document> {
    return this.backendService.getData(this.documentContentUrl.replace('{documentId}', documentId));
  }
  checkIfAddressRequired(merchantId: string) {
    let url = this.checkIfAddressRequiredUrl;
    if (!environment.production) {
      url = url.replace('{environment}', 'staging-');
    } else {
      url = url.replace('{environment}', '');
    }
    return this.backendService.getData(url.replace('{merchantId}', merchantId), 'text', false, true, false, true);
  }
  savePoaAddress(address: PoaAddress) {
    address.CustomerId = this.tokenService.getCustomerId();
    address.TrustedMerchantId = this.applicationService.getMerchantId();
    return this.backendService.setData(this.savePoaAddressUrl, address);
  }
  getMerchantDocuments(customerId: string): Observable<Document[]> {
    return this.backendService.getData(this.documentUrl.replace('{customerId}', customerId));
  }
  saveMerchantDocument(customerId: string, documentCategory: string, documentLabel: string, name: string, ext: string, content: string, isAdditionalDocument: boolean): Observable<any> {
    if (documentLabel === ProofOfId.FrontOfAadhaar.toString() || documentLabel === ProofOfAddress.BackOfAadhaar.toString()) {
      documentLabel = 'Aadhaar';
    }
    const documentData = {
      documentCategory: documentCategory,
      documentLabel: documentLabel,
      fileName: name,
      fileExtension: ext,
      documentContent: content,
      isAdditionalDocument: isAdditionalDocument,
      merchantIdSource: this.applicationService.getMerchantId(),
      applicationContext: null
    };
    return this.backendService.setData(this.documentUrl.replace('{customerId}', customerId), documentData);

  }
  removeDuplicatesDocuments(dataArray: Document[]) {
    const uniqueArray: Document[] = [];
    let docNotFound = false;
    dataArray.forEach(doc => {
      docNotFound = true;
      uniqueArray.forEach(uniqueDoc => {
        if (uniqueDoc.fileName === doc.fileName && uniqueDoc.fileSize === doc.fileSize) {
          docNotFound = false;
          return;
        }
      });
      if (docNotFound) {
        uniqueArray.push(doc);
      }
    });
    return uniqueArray;
  }
  checkForNewKycPage(merchantId: string): Observable<KycPageResponse> {
    return this.backendService.getData(this.checkForNewKycPageUrl.replace('{merchantId}', merchantId));
  }

  patchKycFlow(postParams: PatchKycFlowUI) {
    return this.backendService.patchData(this.patchKycUrl, postParams);
  }

  getDoorStepFlag() {
    return this.backendService.getData(this.doorstepFeatureSwitch, null, false, true, true);
  }
}
